import { Container } from 'js-data'
import { addAction } from 'js-data-http'
import VeroFreshApiAdapter from './VeroFreshApiAdapter'
import BaseMapper from './BaseMapper'
import { kebabCase, forEach } from 'lodash'

const ApiContainer = new Container()
ApiContainer.registerAdapter('http', VeroFreshApiAdapter, { default: true })

/**
 * autoload all models from the models directory
 */
const requireModels = require.context('./models', false, /\.js$/)

requireModels.keys().forEach(fileName => {
  // filter fullstops and extension and return a camel-case name for the file
  const modelName = fileName.replace(/(\.\/|\.js)/g, '')
  const mapperName = modelName.replace(/Record$/g, '')
  const MapperClass = requireModels(fileName).default
  MapperClass.prototype.$className = modelName

  ApiContainer.defineMapper(mapperName, {
    recordClass: MapperClass,
    endpoint: MapperClass.endpoint || kebabCase(mapperName),
    mapperClass: BaseMapper,
    relations: requireModels(fileName).relations
  })

  const modelActions = requireModels(fileName).actions

  if (modelActions !== undefined) {
    forEach(modelActions, function (actionDefinition, actionName) {
      addAction(actionName, actionDefinition)(ApiContainer.getMapper(mapperName))
    })
  }
})

export default ApiContainer
